import React, {useCallback, useContext, useEffect, useState} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu, findParent} from '../../../hooks/useMenu';
import ProvingTN from './provingTN';
import CommandsContext from '../../../context/commandsContext';

function Proving({onExit, continueProving, initiallyDisableKeypress}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, setSelected, onComponent, items} = useMenu();
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    if (continueProving) {
      const parent = findParent(null, items, selected);
      setSelected(parent.children[0]);
      onComponent(null);
      return;
    }

    setSelected(selected.children[0]);
    onExit();
  }, []);

  const onRight = useCallback(() => {
    onComponent(<ProvingTN />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft, onRight});
    });
  }, [onLeft, onRight]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="Proving Setup"
      left="No"
      right="Yes"
      caption="The setup for Proving may change your configuration.  Do you want to save your configuration first?"
    />
  );
}

export default Proving;
